import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { PostListSkeleton } from '@/components/ui/Skeleton'

import { useCurrentUser } from '../hooks/useCurrentUser'

/** 受保护路由：加载中显示骨架，未登录跳 /login?next= */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useCurrentUser()
  const location = useLocation()

  if (isLoading) return <PostListSkeleton />

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?next=${next}`} replace />
  }

  return <>{children}</>
}

/** 已登录时不该再看到登录 / 注册页 */
export function RedirectIfAuthenticated({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useCurrentUser()
  if (isLoading) return null
  if (isAuthenticated) return <Navigate to="/" replace />
  return <>{children}</>
}
